export default {
  title: 'MAXHUB 设备激活',
  instruction: '请准确填写用户及经销商信息，此信息将直接影响机器保修及后续延保等商机提供。',
  dealername: '销售经销商',
  dealerplaceholder: '经销商名称(必填)',
  companyname: '公司名称',
  companyplaceholder: '公司名称(必填)',
  tele: '联系电话',
  teleplaceholder: '客户手机或固话(必填)',
  district: '选择地区',
  distplaceholder: '地区信息(必选)',
  address: '详细地址',
  addrplaceholder: '街道门牌信息(必填)',
  activebtn: '获取激活码',
  confirmbtn: '确认',
  cancelbtn: '取消',
  dialogmessage: '您输入的联系电话格式有误，请重新输入',
  dialogbtn: '确认',
  errortitle: '无法打开',
  errorinfo1: '1.尝试网络检查',
  errorinfo2: '2.电话客服专线：400-168-9545',
  nosn: '该设备无SN码，无法激活',
  activepagetitle: '设备激活码',
  activepagehint: '请在设备上输入激活码完成设备激活',
  finish: '完成',
  search: '搜索附近位置'
};



// WEBPACK FOOTER //
// ./src/i18n/_zh-CN.js